<template>
    <v-card min-width="21vw" align="center" justify="center" outlined>
        <v-card-title >
            <v-list-item>
                <v-list-item-title><h2>{{ sharingDetails.requestedBy.firstName }}'s Request</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 pt-7">
            <div class="d-flex align-center justify-center">
                <v-avatar v-if="sharingDetails.requestedBy.imageUrl != null" class="mr-3" size="49"><v-img :src="sharingDetails.requestedBy.imageUrl" contain></v-img></v-avatar>
                <p class="mb-0"><b>{{ sharingDetails.requestedBy.firstName }} {{ sharingDetails.requestedBy.lastName }}</b> wants to see your journal</p>
            </div>
            <div class="d-flex align-center justify-center my-5">
                <v-btn @click="action('APPROVED')">Approve Request</v-btn>
                <v-btn class="ml-3" @click="action('DENIED')">Deny Request</v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../../repositories/sharing';
    export default {
        name: "ShareRequestDetails",
        props: {
            sharingDetails: Object,
        },
        methods: {
            action(type) {
                this.sharingDetails.shareStatus = type;
                Repository.updateShareRequest(this.sharingDetails).then((response) => {
                    if(response.status < 400) {
                        this.closeWindow();
                    }
                });
            },
            closeWindow() {
                this.$emit('closeWindow');
            },
        }
    }
</script>

<style scoped>

</style>
